import type { BadgeTone } from '@/app/components/ui/Badge';
import type { DocumentStatus } from '@/features/documents/types';

/** `gepubliceerd` reads as the active/live state — mint, same "no separate
 * success tone" spirit as `communications/statusTone.ts`. `archief` is
 * neutral. */
export function statusTone(status: DocumentStatus): BadgeTone {
  if (status === 'gepubliceerd') return 'mint';
  return 'outline';
}
